import React from 'react';
import { useDocTitle } from '../components/CustomHook';
import SEOMetaTags from '../components/SEOMetaTags';
import StructuredData from '../components/StructuredData';
import Navbar from '../components/navbar/Navbar';
import Footer from '../components/Footer';
import ContactFormWidget from '../components/ContactFormWidget';

const PrivateAnfrage = () => {
  useDocTitle('Kontakt-Anfrage | Schmid Energieberatung');


  return (
    <>
      <SEOMetaTags
        title="Kontakt-Anfrage - Energieberatung Schmid"
        description="Kontaktieren Sie uns für eine persönliche Energieberatung. Ihre Anfrage wird professionell und zeitnah bearbeitet."
        keywords="Kontakt, Energieberatung, Anfrage, Photovoltaik, Wärmepumpe, Beratung"
        url="https://www.schmid-energieberatung.de/anfrage"
      />

      <StructuredData
        type="ContactPage"
        data={{
          name: "Kontakt-Anfrage - Schmid Energieberatung",
          description: "Kontaktformular für persönliche Energieberatung und Anfragen",
          url: "https://www.schmid-energieberatung.de/anfrage"
        }}
      />

      <div className="min-h-screen bg-white">
        <Navbar />

        <main>
          {/* Hero Section */}
          <section className="bg-primary py-16">
            <div className="container mx-auto px-6 text-center">
              <h1 className="text-4xl md:text-5xl font-bold text-white mb-6">
                Kontakt-Anfrage
              </h1>
              <p className="text-xl text-secondary-light mb-8 max-w-3xl mx-auto">
                Nehmen Sie Kontakt mit uns auf für eine persönliche Energieberatung.
                Wir freuen uns auf Ihre Anfrage und melden uns zeitnah bei Ihnen zurück.
              </p>
              <div className="flex flex-wrap justify-center gap-4 text-secondary-light">
                <div className="flex items-center">
                  <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd"/>
                  </svg>
                  Persönliche Beratung
                </div>
                <div className="flex items-center">
                  <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd"/>
                  </svg>
                  Schnelle Rückmeldung
                </div>
                <div className="flex items-center">
                  <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd"/>
                  </svg>
                  Kostenlose Erstberatung
                </div>
              </div>
            </div>
          </section>

          {/* Contact Form Section */}
          <section className="py-16">
            <div className="max-w-4xl mx-auto">
                <ContactFormWidget />
            </div>
          </section>

        </main>

        <Footer />
      </div>
    </>
  );
};

export default PrivateAnfrage;